// @flow

export default Object.freeze({
  GET_SERVICE_AREA: 'GET_SERVICE_AREA',
  GET_SERVICE_AREA_ERROR: 'GET_SERVICE_AREA_ERROR',
  GET_SERVICE_AREA_START: 'GET_SERVICE_AREA_START',
  GET_SERVICE_AREA_SUCCESS: 'GET_SERVICE_AREA_SUCCESS',
  GET_SERVICE_AREA_RESET: 'GET_SERVICE_AREA_RESET',
  SEARCH_CITIES: 'SEARCH_CITIES',
  SEARCH_CITIES_ERROR: 'SEARCH_CITIES_ERROR',
  SEARCH_CITIES_START: 'SEARCH_CITIES_START',
  SEARCH_CITIES_SUCCESS: 'SEARCH_CITIES_SUCCESS',
  SEARCH_CITIES_RESET: 'SEARCH_CITIES_RESET',
  GET_CITY_DETAILS: 'GET_CITY_DETAILS',
  GET_CITY_DETAILS_ERROR: 'GET_CITY_DETAILS_ERROR',
  GET_CITY_DETAILS_START: 'GET_CITY_DETAILS_START',
  GET_CITY_DETAILS_SUCCESS: 'GET_CITY_DETAILS_SUCCESS',
  GET_CITY_DETAILS_RESET: 'GET_CITY_DETAILS_RESET',
  SET_SERVICE_AREA: 'SET_SERVICE_AREA',
  SET_SERVICE_AREA_ERROR: 'SET_SERVICE_AREA_ERROR',
  SET_SERVICE_AREA_START: 'SET_SERVICE_AREA_START',
  SET_SERVICE_AREA_SUCCESS: 'SET_SERVICE_AREA_SUCCESS',
  SET_SERVICE_AREA_RESET: 'SET_SERVICE_AREA_RESET',
});



// WEBPACK FOOTER //
// ./src/app/common/service-area/serviceAreaMapActionKeys.js